import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

function userFromMeResponse(data) {
  if (data && data.username) {
    return { username: data.username };
  }
  return null;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ beim Laden prüfen ob Cookie gültig
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch("https://lborrito.de/api/auth/me", {
          credentials: "include",
        });
        if (res.ok) {
          const data = await res.json();
          setUser(userFromMeResponse(data));
        } else {
          setUser(null);
        }
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  const login = async (username, password, turnstileToken) => {
    const res = await fetch("https://lborrito.de/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // 🔑 Cookie setzen
      body: JSON.stringify({ username, password, turnstileToken }),
    });

    if (res.ok) {
      const me = await fetch("https://lborrito.de/api/auth/me", {
        credentials: "include",
      });
      if (me.ok) {
        const data = await me.json();
        setUser(userFromMeResponse(data));
      }
    } else {
      // Verschiedene Fehlertypen unterscheiden
      if (res.status === 429) {
        throw new Error("TOO_MANY_REQUESTS");
      } else if (res.status === 401) {
        // 401 kann Captcha-Fehler ODER falsches Passwort sein
        const errorBody = await res.json().catch(() => ({}));
        if (errorBody.error === "TOO_MANY_REQUESTS") {
          throw new Error("TOO_MANY_REQUESTS");
        } else if (errorBody.message && errorBody.message.includes("Captcha")) {
          throw new Error("CAPTCHA_FAILED");
        } else {
          throw new Error("INVALID_CREDENTIALS");
        }
      } else {
        throw new Error("LOGIN_FAILED");
      }
    }
  };

  const logout = async () => {
    await fetch("https://lborrito.de/api/auth/logout", {
      method: "POST",
      credentials: "include",
    });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
